import { render, staticRenderFns } from "./CowProposal.vue?vue&type=template&id=bb544774&scoped=true&"
import script from "./CowProposal.vue?vue&type=script&lang=js&"
export * from "./CowProposal.vue?vue&type=script&lang=js&"
import style0 from "./CowProposal.vue?vue&type=style&index=0&id=bb544774&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb544774",
  null
  
)

export default component.exports